var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isButton)?_c('b-button',{staticClass:"begin-today-button",attrs:{"tag":"div"},on:{"click":_vm.click}},[_vm._v("\n  Begin Today\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }